import React from 'react';
import './ProductTypeSelector.css';
import AppIcon from './icons/AppIcon';

const ProductTypeSelector = ({ onSelect, onCancel }) => {
  const tipos = [
    {
      id: 'geral',
      nome: 'Produto Geral',
      descricao: 'Produtos comuns do catálogo',
      icone: 'inventory_2',
      cor: '#4f46e5'
    },
    {
      id: 'gas_distributor',
      nome: 'Distribuidora Gás e Água',
      descricao: 'Botijões, água mineral e similares',
      icone: 'local_fire_department',
      cor: '#f97316'
    }
  ];

  return (
    <div className="product-type-selector">
      <div className="selector-header">
        <h3>Selecione o Tipo de Produto</h3>
        <p>Escolha o tipo para carregar os campos corretos</p>
      </div>

      <div className="selector-options">
        {tipos.map((tipo) => (
          <div
            key={tipo.id}
            className="selector-option"
            onClick={() => onSelect(tipo.id)}
            style={{ '--option-color': tipo.cor }}
          >
            <div className="option-icon">
              <AppIcon name={tipo.icone} />
            </div>
            <div className="option-info">
              <h4>{tipo.nome}</h4>
              <p>{tipo.descricao}</p>
            </div>
            <div className="option-arrow">
              <AppIcon name="arrow_forward" />
            </div>
          </div>
        ))}
      </div>

      <div className="selector-footer">
        <button className="btn-secondary" onClick={onCancel}>
          Cancelar
        </button>
      </div>
    </div>
  );
};

export default ProductTypeSelector;
